import React from 'react';

import Section from '@common/Section';
import Container from '@common/Container';
import Row from '@common/Row';
import Heading from '@common/Heading';
import Img from '@common/Image';
import Link from '@common/Link';

const LinkList = ({ data }) => {
  const {
    title,
    list
  } = data;
  return (
    <Section>
      <Container className='rounded bg-white p-4'>
        {title && <Heading type='h2' className='mb-4 text-center col-8 mx-auto'>{title}</Heading>}
        {list &&
          <Row className='row-cols-2 row-cols-lg-4 align-content-stretch g-3'>
            {list.map((item, index) => (
              <div key={index} className='d-flex'>
                <Link to={item.link} className='d-flex flex-fill'>
                  <div className='d-flex flex-fill bg-white shadow justify-content-center p-3' style={{borderRadius:'10px'}}>
                    <Img image={item.image.gatsbyImageData} file={item.image.file}/>
                  </div>
                </Link>
              </div>
            ))}
          </Row>
        }
      </Container>
    </Section>
  );
};

export default LinkList
